import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Lock } from "lucide-react";
import { toast } from "sonner";
import { adminLogin } from "@/lib/api";
import { IONA } from "@/constants/site";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { token } = await adminLogin(email, password);
      localStorage.setItem("iona_admin_token", token);
      toast.success("Giriş başarılı");
      navigate("/admin/dashboard");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Giriş başarısız");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      data-testid="admin-login-page"
      className="min-h-screen flex items-center justify-center bg-gradient-to-br from-[#F4F1F9] via-white to-[#F8F9FA] px-4"
    >
      <div className="w-full max-w-md">
        <div className="bg-white rounded-3xl p-10 border border-[#F0F0F0] iona-soft-shadow">
          <div className="flex flex-col items-center mb-8">
            <div className="w-16 h-16 rounded-full bg-[#5E2A84] flex items-center justify-center overflow-hidden p-2 mb-5">
              <img src={IONA.logo} alt="İONA" className="w-full h-full object-contain" />
            </div>
            <h1 className="font-serif text-3xl text-[#1A1A1A] mb-2">
              Admin Girişi
            </h1>
            <p className="text-sm text-[#4A4A4A]">
              İONA blog yönetim paneline hoş geldiniz
            </p>
          </div>

          <form onSubmit={submit} className="space-y-5">
            <div className="space-y-2">
              <Label htmlFor="email" className="text-[#1A1A1A]">E-posta</Label>
              <Input
                id="email"
                data-testid="admin-email-input"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="admin@iona.com"
                required
                className="h-12 rounded-full px-5 border-[#E5E5E5] focus:border-[#5E2A84] focus-visible:ring-[#5E2A84]"
              />
            </div>
            <div className="space-y-2">
              <Label htmlFor="password" className="text-[#1A1A1A]">Şifre</Label>
              <Input
                id="password"
                data-testid="admin-password-input"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                required
                className="h-12 rounded-full px-5 border-[#E5E5E5] focus:border-[#5E2A84] focus-visible:ring-[#5E2A84]"
              />
            </div>
            <Button
              type="submit"
              data-testid="admin-login-submit"
              disabled={loading}
              className="w-full h-12 rounded-full bg-[#5E2A84] hover:bg-[#4a2168] text-white"
            >
              <Lock className="w-4 h-4 mr-2" />
              {loading ? "Giriş yapılıyor..." : "Giriş Yap"}
            </Button>
          </form>
        </div>
        <div className="text-center mt-6">
          <a
            href="/"
            className="text-sm text-[#4A4A4A] hover:text-[#5E2A84]"
            data-testid="admin-back-home"
          >
            ← Anasayfaya Dön
          </a>
        </div>
      </div>
    </div>
  );
}
